import store from './../redux/store'

export const getUserToken = ()=>store.getState().user.token

export function scrollDown(){
    window.scrollTo(0,document.body.scrollHeight);
}